import { render, staticRenderFns } from "./DataTable.vue.js?vue&type=template&id=3ff2819e&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=template&id=3ff2819e&scoped=true"
import script from "./DataTable.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue.scss?vue&type=style&index=0&id=3ff2819e&prod&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=style&index=0&id=3ff2819e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2819e",
  null
  
)

export default component.exports